<template>
 <div :class="windowClass">
      <v-toolbar class="ma-2" dense flat>
        <v-spacer/>
         <v-btn class="ma-1" small color="error" v-if="purchase.status=='on-process'" @click="confirm=true"><v-icon left>mdi-cancel</v-icon> Cancel</v-btn>
        <v-btn class="ma-1" small v-if="purchase.status=='return empties' || purchase.status=='standby'" @click="purchase.status ='on-process',Save()"><v-icon left>mdi-check</v-icon> Re-Process</v-btn>
        <v-btn class="ma-1" small color="secondary" v-if="purchase.status=='on-process'" @click="purchase.status ='return empties',Save()"><v-icon left>mdi-arrow-right</v-icon> return empties</v-btn>
        <v-btn class="ma-1" small color="warning" v-if="purchase.status=='return empties'" @click="purchase.status ='standby',Save()"><v-icon left>mdi-square</v-icon> standby</v-btn>
        <v-btn class="ma-1" small color="success" v-if="purchase.status=='return empties' || purchase.status=='standby'" @click="purchase.status ='delivered',Save()"><v-icon left>mdi-download-outline</v-icon> delivered</v-btn>
      </v-toolbar>
        <v-row class="ma-1">
            <v-col cols="3">
                <v-text-field
                  v-model="purchase.number"
                  label="P.O. #:"
                  :disabled="!EDIT"
                  dense
                  outlined
                  filled
                />
                 <v-autocomplete
                  v-model="purchase.supplier"
                  label="SUPPLIER"
                  :items="$store.state.suppliers"
                  item-text="company"
                   :disabled="!EDIT"
                  item-value="id"
                  dense
                  outlined
                  filled
                />
                <v-text-field
                 :value="SELECTSUPPLIER.number"
                  label="CONTACT #:"
                  dense
                  outlined
                  filled
                   :disabled="!EDIT"
                />
            </v-col>  
             <v-col cols="3">
                <v-text-field
                  label="P.O. DATE:"
                  :value="purchase.created | moment('YYYY-MM-DD')"
                  dense
                  outlined
                  :disabled="true"
                  filled
                />
                 
                <v-text-field
                  :value="SELECTSUPPLIER.address"
                  label="ADDRESS:"
                   :disabled="!EDIT"
                  dense
                  outlined
                  filled
                />

                <v-autocomplete
                  v-model="purchase.payment_type"
                  label="PAYMENT TYPE:"
                   :disabled="!EDIT"
                  :items="['Cash','Cheque', 'Credit']"
                  dense
                  outlined
                  filled
                />
            </v-col>
             <v-col cols="3">
                 <v-autocomplete
                  v-model="purchase.truck"
                  label="ASSIGNED TRUCK"
                  :items="$store.state.trucks"
                  item-text="name"
                  item-value="id"
                   :disabled="!EDIT"
                  dense
                  outlined
                  filled
                />
                <div class="md-font mb-6 mt-1">
                  Plate No.: {{TRUCK.plate_number != undefined?TRUCK.plate_number:'N/A'}} <br />
                  Load Capacity: Volume {{TRUCK.capacity}} m&sup3; | Weight {{TRUCK.weight}} kg
                </div>
                <v-autocomplete
                  v-model="purchase.driver"
                  label="ASSIGNED DRIVER"
                   :disabled="!EDIT"
                  :items="$store.state.drivers"
                  item-text="fullname"
                  item-value="id"
                  dense
                  outlined
                  filled
                />
                
            </v-col>
             <v-col cols="3">
                 <v-text-field
                  v-model="purchase.invoice_number"
                   :disabled="!EDIT"
                  label="SALES INVOICE"
                  dense
                  outlined
                  filled
                />
                  <v-autocomplete
                  v-model="purchase.payment_status"
                  label="PAYMENT STATUS:"
                  :items="['Paid','Unpaid']"
                  dense
                  outlined
                  filled
                   :disabled="!EDIT"
                />
                 <v-text-field
                  v-model="purchase.status"
                  label="P.O. STATUS"
                  dense
                  :disabled="true"
                  outlined
                  filled
                  
                />
            </v-col>

             <v-col cols="12">
                <v-card>
                  <v-toolbar dense color="secondary" dark>
                     EMPTIES - DEPOSIT/REFUND
                        <v-spacer/>
                     <v-icon @click="emptyform=true" v-if="purchase.status !='delivered'">mdi-plus-box</v-icon>
                  </v-toolbar>
                  
                       <v-data-table
                    class="va-table mt-4"
                    dense
                    :headers="empties_headers"
                    :items="empties"
                    disable-pagination
                    hide-default-footer
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                          <td>{{item.product_code}}</td>
                          <td>{{item.description}}</td>
                          <td class="text-right" width="70">
                            <input 
                              type="number"
                                class="va-input pa-1"
                               v-model="item.refund"
                                :disabled="!EDIT"
                                @change="SaveItem(item)"
                              />
                          </td>
                           <td class="text-right" width="70">
                             <input 
                             class="va-input pa-1"
                              type="number"
                               v-model="item.deposit"
                               :disabled="true"
                              />
                           
                          </td>
                            <td class="text-right">{{$money(($IsNum(item.deposit) - $IsNum(item.refund)) * $IsNum(item.unit_price)  )}}</td>
                        </tr>
                          <tr style="background: #efefef;">
                              <th colspan="4" class="text-right">TOTAL NET DEPOSIT/REFUND</th>
                              <th class="text-right">{{$money(EMTPTIESTOTAL)}}</th>
                          </tr>
                        </tbody>
                    </template>
                </v-data-table>
                
                </v-card>
             </v-col>

              <v-col cols="12">
                <v-card>
                  <v-toolbar dense color="secondary" dark>
                     FULL CONTENTS
                     <v-spacer/>
                     <v-icon @click="fullform=true" v-if="purchase.status !='delivered'">mdi-plus-box</v-icon>
                  </v-toolbar>
                  
                       <v-data-table
                    class="va-table"
                    dense
                    :headers="full_headers"
                    :items="fulls"
                    disable-pagination
                    hide-default-footer
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                          <td><v-icon v-if="EDIT" small left color="error" @click="RemoveFullItem(item)">mdi-delete</v-icon> {{item.product_code}}</td>
                          <td>{{item.description}}</td>
                           <td class="text-right">{{item.quantity}}</td>
                              <td class="text-right">{{$money(item.unit_price)}}</td>
                          <td class="text-right">{{$money($IsNum(item.unit_price) * $IsNum(item.quantity) )}}</td>
                        </tr>
                         <tr style="background: #efefef;">
                              <th colspan="4" class="text-right">TOTAL GROSS VALUE SOLD</th>
                              <th class="text-right">{{$money(GROSSTOTAL)}}</th>
                          </tr>
                        </tbody>
                    </template>
                </v-data-table>
                
                </v-card>
             </v-col>

             <v-col cols="12">
                <v-card>
                  <v-toolbar dense color="secondary" dark>
                     LESS DISCOUNTS
                     <v-spacer/>
                     
                  </v-toolbar>
                  
                       <v-data-table
                    class="va-table"
                    dense
                    :headers="discount_headers"
                    :items="discounts"
                    disable-pagination
                    hide-default-footer
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                           <td>{{item.description}}</td>
                            <td class="text-right">{{$money(item.amount)}}</td>
                        </tr>
                        </tbody>
                    </template>
                </v-data-table>
                
                </v-card>
             </v-col>

             <v-col cols="12">
                <v-card>
                 
                  
                      <table class="va-table md-font" width="100%">
                          <tr style="background: #efefef;">
                            <th class="text-left pa-2">TOTAL NET VALUE SOLD - CONTENTS</th>
                            <th class="text-right pa-2">{{$money(GROSSTOTAL-DISCOUNTTOTAL)}}</th>
                          </tr>
                            <tr style="background: #efefef;">
                            <th class="text-left pa-2">GRAND TOTAL - VALUE OF GOODS SOLD</th>
                            <th class="text-right pa-2">{{$money(GROSSTOTAL-DISCOUNTTOTAL+EMTPTIESTOTAL)}}</th>
                          </tr>
                      </table>
                
                </v-card>
             </v-col>
        </v-row>
     <va-full-form :show="fullform" method="purchase" :itemid="parseInt($route.params.id)" @DialogEvent="fullEvent"/>
      <va-empty-form :show="emptyform"  method="purchase" :itemid="parseInt($route.params.id)" @DialogEvent="fullEvent"/>
      <va-confirm :show="confirm" cancelbtn="No" okbtn="cancel" text="Would you like to cancel this po?" @DialogEvent="cEvent"/>
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
        fullform: false,
        confirm: false,
        emptyform: false,
        empties_headers: [
        { text: 'CODE', value: 'product_code', sortable: false},
        { text: 'DESC', value: 'description', sortable: false},
        { text: 'REFUND', align: 'center', value: 'refund', sortable: false},
        { text: 'DEPOSIT', align: 'center', value: 'deposit', sortable: false},
        { text: 'AMOUNT',  align: 'right',sortable: false },
         ],
         full_headers: [
        { text: 'CODE', value: 'product_code', sortable: false},
        { text: 'DESC', value: 'description', sortable: false},
        { text: 'QTY', value: 'quantity', align: 'right', sortable: false},
        { text: 'UNIT PRICE', align: 'right', value: 'unit_price', sortable: false},
        { text: 'AMOUNT',  align: 'right',sortable: false },
         ],

          discount_headers: [
          { text: 'DESC', value: 'description', sortable: false},
          { text: 'AMOUNT',  align: 'right',sortable: false },
         ],

        DiscountTypes: ["Trade Deals", "Pick-up Discount", "Cash Discount", "Other"],
        PoID:0,
        purchase:{},
        empties: [],
        discounts:[],
        fulls: []
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.SET_MENUS()
          this.setLoggedIn(true) 
          this.GET_SUPPLIERS()
          this.GET_TRUCKS()
           this.GET_DRIVERS()
           this.GET_PRODUCTS()
          this.PoID = parseInt(this.$route.params.id)
          this.getPurchase()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      EDIT() {
        if(this.purchase.status!='delivered'){
            return true
        }
        return false
      },
      SELECTSUPPLIER() {
           var arr = this.$store.state.suppliers.reduce((res, item)=>{
            if(item.id==this.purchase.supplier) {
             res = item
            }
            return res
        },{})
        return arr
      },
      TRUCK() {
         if(this.$store.state.trucks == undefined || this.$store.state.trucks == null) {
          return []
        }
        var arr = this.$store.state.trucks.reduce((res, item)=>{
            if(item.id==this.purchase.truck) {
             res = item
            }
            return res
        },{})
        return arr
      },
      CONTAINERS(){
        var arr =  this.$store.state.products.reduce((res, item)=>{
            if(item.type=="empties"  && item.sort>0) {
                res.push(item)
            }
            return res
        },[])
        return arr
      },
      EMTPTIESTOTAL() {
        var total =  this.empties.reduce((res, item)=>res += (this.$IsNum(item.deposit) - this.$IsNum(item.refund)) * this.$IsNum(item.unit_price),0)
        return total
      },
      GROSSTOTAL() {
        var total =  this.fulls.reduce((res, item)=>res += this.$IsNum(item.quantity)* this.$IsNum(item.unit_price),0)
        return total
      },
       DISCOUNTTOTAL:function(){
         var total =  this.discounts.reduce((res, item)=>res += this.$IsNum(item.amount),0)
        return total
        },
        GRANDTOTAL() {
          return this.GROSSTOTAL - this.DISCOUNTTOTAL + this.EMTPTIESTOTAL
        }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      fullEvent() {
        this.fullform = false
        this.emptyform = false
         this.getPurchase()
      },
      getPurchase() {
        this.$http.post("purchase/view", {id:this.PoID}).then(response => {
              response.data.purchase != null?this.purchase = response.data.purchase:this.purchase={}
             response.data.empties != null?this.empties = response.data.empties:this.empties=[]
              response.data.fulls != null?this.fulls = response.data.fulls:this.fulls=[]
              response.data.discounts != null?this.discounts = response.data.discounts:this.discounts=[]
          }).catch(e => {
           console.log(e.data)
         })
      },
       Save() {
         this.purchase.paid_amount = this.GRANDTOTAL.toString()
         console.log(this.purchase)
        this.$http.post("purchase/update", this.purchase).then(response => {
              response.data.status?this.VA_ALERT("success", response.data.message):this.VA_ALERT("error", response.data.message)
          }).catch(e => {
           console.log(e.data)
         })
      },
      SaveItem(item) {
        this.$http.post("purchase/save_item", item).then(response => {
              response.data.status?this.VA_ALERT("success", response.data.message):this.VA_ALERT("error", response.data.message)
           this.getSales()
         }).catch(e => {
           console.log(e.data)
         })
      },
      RemoveFullItem(item) {
        this.$http.post("purchase/remove_item", item).then(response => {
              response.data.status?this.VA_ALERT("success", response.data.message):this.VA_ALERT("error", response.data.message)
           this.getPurchase()
         }).catch(e => {
           console.log(e.data)
         })
      },
      cEvent(data) {
        this.confirm = false
        if(data != 'cancel') {
            this.removePo()
        }
      },
      removePo() {
        this.$http.post("purchase/delete", this.purchase).then(response => {
              this.GET_RESPONSE(response)
             setTimeout(()=>{
               this.$router.go(-1)
             }, 700)
             
          }).catch(e => {
           console.log(e.data)
         })
      },
    },
  }
</script>